import { render } from "./ThemeCopy.vue?vue&type=template&id=4691e162"
import script from "./ThemeCopy.vue?vue&type=script&lang=js"
export * from "./ThemeCopy.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__